import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { AuthGuardMain } from "../auth/auth-guard.service";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("../main/dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "users",
        loadChildren: () =>
          import("../main/user/user.module").then((m) => m.UserModule),
      },
      {
        path: "setting",
        loadChildren: () =>
          import("../main/setting-management/setting-management.module").then((m) => m.SettingManagementModule),
      },
      {
        path: "manager",
        loadChildren: () =>
          import("../main/manager-management/manager-management.module").then((m) => m.ManagerManagementModule),
      },
      {
        path: "support",
        loadChildren: () =>
          import("../main/supports/supports.module").then((m) => m.SupportsModule),
      },
      {
        path: "cards",
        loadChildren: () =>
          import("../main/cards/cards.module").then((m) => m.CardsModule),
      },
     
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
